import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Password Expired field definition
 * Boolean field with Yes/No dropdown for password expiration status filtering
 */
export const ADObjectPasswordExpired = createBooleanSimpleFilterDefinition(
  'passwordexpired',
  'Password Expired'
);
